// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import { PharmacyActions, PharmacyActionTypes } from '../_actions/pharmacy.actions';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { Pharmacy } from '../_models/pharmacy.model';

// tslint:disable-next-line:no-empty-interface
export interface PharmaciesState extends EntityState<Pharmacy> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedPharmacyId: number;
  lastQuery: QueryParamsModel;
  error: any;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<Pharmacy> = createEntityAdapter<Pharmacy>();

export const initialPharmaciesState: PharmaciesState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  latestSuccessfullAction: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedPharmacyId: undefined,
  showInitWaitingMessage: true,
});

export function pharmaciesReducer(
  state = initialPharmaciesState,
  action: PharmacyActions,
): PharmaciesState {
  switch (action.type) {
    case PharmacyActionTypes.PharmaciesPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedPharmacyId: undefined,
      };
    case PharmacyActionTypes.PharmaciesActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case PharmacyActionTypes.PharmacyCreated:
      return adapter.addOne(action.payload.pharmacy, {
        ...state,
        lastCreatedPharmacyId: action.payload.pharmacy.id,
      });
    case PharmacyActionTypes.PharmacyUpdated:
      return adapter.updateOne(action.payload.partialPharmacy, state);
    case PharmacyActionTypes.PharmacyDeleted:
      return adapter.removeOne(action.payload.id, state);
    case PharmacyActionTypes.PharmaciesPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case PharmacyActionTypes.PharmaciesPageLoaded: {
      return adapter.addMany(action.payload.pharmacies, {
        ...initialPharmaciesState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    }
    case PharmacyActionTypes.ThrowPharmacyError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case PharmacyActionTypes.FirePharmacySuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getPharmacyState = createFeatureSelector<PharmaciesState>('pharmacies');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
